/* @flow */
export default {
  methods: {
    validateForm(group: string, successCb: Function, errorCb: Function) {
      const v = group ? this.$v[group] : this.$v;
      v.$touch();
      if (v.$invalid) {
        errorCb && errorCb(); //eslint-disable-line
      } else {
        successCb && successCb(); //eslint-disable-line
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/validateForm.js